import React, { useContext } from 'react';
import tw from 'twin.macro';
import { AppContext } from '../context';
import { TextLine } from '../text';
import { NavLink } from './';

export const menuStyle = tw`relative cursor-pointer block p-2 border-l-0 
  hover:text-default hover:pl-4 border-l-4 border-transparent transition-all`;

export const opacityStyle = tw`opacity-60`;

export const MenuNavLink = ({ to, label }) => {
  const { slideIn, setSlideIn } = useContext(AppContext);
  return (
    <NavLink to={to} onClick={() => setSlideIn({ ...slideIn, active: false })} sidebarLink>
      <TextLine text={label} css={[opacityStyle]} />
    </NavLink>
  );
};
